// extracted by mini-css-extract-plugin
export default {"crossStyle":"errorModal_crossStyle__4wvIO","modalStyle":"errorModal_modalStyle__nGZJv"};